import { Action } from '../../Action';

export enum StoreActionType {
  STORE_CHANGED = 'STORE_CHANGED',
  LANGUAGE_CHANGED = 'LANGUAGE_CHANGED',
}

export interface GetStoreChangeActionType extends Action {
  type: StoreActionType.STORE_CHANGED;
  payload: {
    storeNumber: string;
  };
}

export interface ChangeLanguageActionType extends Action {
  type: StoreActionType.LANGUAGE_CHANGED;
  payload: {
    language: string;
  };
}

export const GetStoreChangeAction = (
  storeNumber: string
): GetStoreChangeActionType => ({
  type: StoreActionType.STORE_CHANGED,
  payload: { storeNumber },
});

export const ChangeLanguageAction = (
  language: string
): ChangeLanguageActionType => ({
  type: StoreActionType.LANGUAGE_CHANGED,
  payload: { language },
});

export type CurrentuserAction =
  | GetStoreChangeActionType
  | ChangeLanguageActionType;
